﻿import { API_URL } from "./config.js";
import { getToken } from "./session.js";
import { trackChange } from "./track.js";

const KEYS = ["watchlists", "screens", "portfolio", "alerts"];
const cache = new Map();
const pending = new Map();
const timers = new Map();

const legacyKey = (name, user) => `trades836_${name}:${(user && user.email) || "guest"}`;
function legacy(name, user) {
  try {
    const raw = localStorage.getItem(legacyKey(name, user));
    return raw ? JSON.parse(raw) : undefined;
  } catch {
    return undefined;
  }
}

function push(name, value) {
  const token = getToken();
  if (!token) return Promise.resolve();
  return fetch(`${API_URL}/me/data/${name}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ value }),
    keepalive: true,
  }).catch(() => {});
}

function flush() {
  for (const [name, value] of pending) push(name, value);
  pending.clear();
  timers.forEach(clearTimeout);
  timers.clear();
}
if (typeof window !== "undefined") {
  window.addEventListener("pagehide", flush);
  document.addEventListener("visibilitychange", () => { if (document.hidden) flush(); });
}

export async function hydrateUserData(user) {
  cache.clear();
  pending.clear();
  const token = getToken();
  if (!token) return false;
  try {
    const res = await fetch(`${API_URL}/me/data`, { headers: { Authorization: `Bearer ${token}` } });
    if (res.status === 401) return false;
    if (res.ok) {
      const data = await res.json();
      for (const [k, v] of Object.entries(data)) cache.set(k, v);
    }
  } catch {
    /* server unreachable: pages start empty */
  }
  for (const name of KEYS) {
    if (!cache.has(name)) {
      const old = legacy(name, user);
      if (old !== undefined) {
        cache.set(name, old);
        push(name, old);
      }
    }
  }
  return true;
}

export function loadUserData(name, user, fallback) {
  return cache.has(name) ? cache.get(name) : fallback;
}

export function saveUserData(name, user, value) {
  trackChange(name, cache.get(name), value);
  cache.set(name, value);
  pending.set(name, value);
  clearTimeout(timers.get(name));
  timers.set(name, setTimeout(() => {
    timers.delete(name);
    pending.delete(name);
    push(name, value);
  }, 400));
}

export function clearUserData() {
  cache.clear();
  pending.clear();
  timers.forEach(clearTimeout);
  timers.clear();
}


